import Vue from 'vue'
import App from './App.vue'
import store from './store'
import VueMeta from 'vue-meta';
import router from './router/index'; //引入路由
import VueRouter from 'vue-router';

Vue.config.productionTip = false

Vue.use(VueMeta);
Vue.use(VueRouter);

// 切换页面回到顶部
router.afterEach((to, from) => {
    window.scrollTo(0, 0);
});

new Vue({
  store,
  data:{
      title:"约剑",
      keywords:"约剑,击剑,击剑比赛,约剑平台,击剑平台，击剑报名，击剑赛事",
      description:"约剑一站式赛事平台，击剑赛事的一站式解决方案。智能报名，编排系统，小程序同步赛事进程。"
  },
  metaInfo(){
      return {
          title: this.title,
          meta: [
              {
                  name:"keywords",
                  content: this.keywords
              },{
                  name:"description",
                  content: this.description
              }
          ]
      }
  },
  router,
  render: h => h(App),
}).$mount('#app')
